export enum EventTrackTypes {
  SuggestBestRoute = `Suggest best route`,
  HomeAnalytics = `Home analytics`,
  Subscribe = `Subscribe`,
  ReferralLink = `Referral link`,
  CloseOpenRoutesHome = `Close open routes home`,
  DeleteAccount = `Delete account`,
  CreateRoute = `Create route`,
  OpenCreateStops = `Open create stops`,
  CreateStops = `Create stops`,
  CopyStops = `Copy stops`,
  ReorderRoute = `Reorder route`,
  DeleteStops = `Delete stops`,
  SkipStop = `Skip stop`,
  SubmitSurvey = `Submit survey`,
  StopTimer = `Stop timer`,
  SearchByVoice = `Search by voice`,
  UpdateApp = `Update app`,
  UserLoggedIn = `User logged in`,
  CloseOpenRoutesModal = `Close open routes modal`,
  CreateReport = `Create report`,
  // CreateTasks = `Create tasks`,
}

export interface SuggestBestRoute {
  type: EventTrackTypes.SuggestBestRoute;
  payload: {
    [`Action`]: `Accept` | `Reject` | `Discard notification` | `Timeout discard`;
  };
}

export interface HomeAnalytics {
  type: EventTrackTypes.HomeAnalytics;
  payload: {
    [`Action`]: `Open`;
    [`Category`]: `Emissions` | `KM` | `Stops`;
  };
}

export type SubscribeFromTypes = `Home` | `Settings` | `Exceeding limits`;
export interface Subscribe {
  type: EventTrackTypes.Subscribe;
  payload: {
    [`Action`]: `Open` | `Subscribe`;
    [`From`]?: SubscribeFromTypes;
  };
}

export interface ReferralLink {
  type: EventTrackTypes.ReferralLink;
  payload: {
    [`Action`]: `Open` | `Copy`;
  };
}

export interface CloseOpenRoutesHome {
  type: EventTrackTypes.CloseOpenRoutesHome;
  payload: {
    [`Action`]: `Close` | `Discard`;
  };
}

export interface DeleteAccount {
  type: EventTrackTypes.DeleteAccount;
  payload: {
    [`Action`]: `Open` | `Confirm`;
  };
}

export type CreateRouteSource = `Home` | `Route list` | `Route completed`;
export interface CreateRoute {
  type: EventTrackTypes.CreateRoute;
  payload: {
    [`From`]: CreateRouteSource;
    [`From transfer`]: boolean;
  };
}

export interface OpenCreateStops {
  type: EventTrackTypes.OpenCreateStops;
  payload: {
    [`Method`]: `Address` | `Manual button` | `Bulk button` | `Map`;
  };
}

export type CreateStopsMethod = `Manual` | `Bulk` | `Map`;
export interface CreateStops {
  type: EventTrackTypes.CreateStops;
  payload: {
    [`Method`]: CreateStopsMethod;
    [`Option`]: `Create route` | `Add to end` | `Reoptimize`;
    [`Stop amount`]: number;
  };
}

export interface CopyStops {
  type: EventTrackTypes.CopyStops;
  payload: {
    [`Action`]: `Open` | `Copy`;
    [`From`]: `Empty route` | `Route action buttons`;
  };
}

export type ReorderRouteFrom = `Mark as next` | `Route action buttons`;
export interface ReorderRoute {
  type: EventTrackTypes.ReorderRoute;
  payload: {
    [`Action`]: `Open` | `Reorder` | `Reoptimize`;
    [`From`]?: ReorderRouteFrom;
  };
}

export interface DeleteStops {
  type: EventTrackTypes.DeleteStops;
  payload: {
    [`Action`]: `Open` | `Delete`;
    [`Amount deleted`]?: number;
  };
}

export interface SkipStop {
  type: EventTrackTypes.SkipStop;
  payload: {
    [`Action`]: `Open` | `Skip`;
  };
}

// export interface CreateTasks {
//   type: EventTrackTypes.CreateTasks;
//   payload: undefined;
// }

export interface SubmitSurvey {
  type: EventTrackTypes.SubmitSurvey;
  payload: {
    Type: `Rating` | `Comment`;
    [`Rating value`]?: number;
  };
}

export interface StopTimer {
  type: EventTrackTypes.StopTimer;
  payload: {
    [`Action`]: `Start` | `Stop`;
  };
}

export type SearchByVoiceSource = `Route stops` | `Stop search` | `Stop creation`;
export interface SearchByVoice {
  type: EventTrackTypes.SearchByVoice;
  payload: {
    [`From`]: SearchByVoiceSource;
  };
}

export interface UpdateApp {
  type: EventTrackTypes.UpdateApp;
  payload: {
    [`Action`]: `Update` | `Discard`;
    [`Version`]: string;
  };
}

export interface UserLoggedIn {
  type: EventTrackTypes.UserLoggedIn;
  payload: {
    [`From`]: `Google` | `Apple` | `Phone number` | `Magic link`;
  };
}

export interface CloseOpenRoutesModal {
  type: EventTrackTypes.CloseOpenRoutesModal;
  payload: {
    [`Action`]: `Close open routes` | `Discard`;
  };
}

export interface CreateReport {
  type: EventTrackTypes.CreateReport;
  payload: {
    [`Has location`]: boolean;
    [`Has signature`]: boolean;
    [`Has comments`]: boolean;
    [`Has images`]: boolean;
    [`Has custom fields`]: boolean;
    [`Has tasks`]: boolean;
    [`Has created tasks`]: boolean;
    [`Is offline`]: boolean;
    [`Status`]: `Completed` | `Canceled` | `Incomplete`;
  };
}

export type EventTrack =
  | SuggestBestRoute
  | HomeAnalytics
  | Subscribe
  | ReferralLink
  | CloseOpenRoutesHome
  | DeleteAccount
  | CreateRoute
  | OpenCreateStops
  | CreateStops
  | CopyStops
  | ReorderRoute
  | DeleteStops
  | SkipStop
  | SubmitSurvey
  | StopTimer
  | SearchByVoice
  | UpdateApp
  | UserLoggedIn
  | CloseOpenRoutesModal
  | CreateReport;
